<!-- =========================================================================================
    File Name: Utenti.vue
    Description: Tabella dei pacchetti di Tariffe + Servizi
    ----------------------------------------------------------------------------------------
    Item Name:
      Author:
    Author URL:
========================================================================================== -->


<template>
    <div>
        <table-pacchetti></table-pacchetti>
    </div>
</template>

<script>

import TablePacchetti from './TablePacchetti.vue'

export default{
    components: {
        TablePacchetti,
    }
}
</script>
